export default {
  extraPlugins: ['mathjax', 'find'],
  customConfig: '',
  mathJaxLib: '//cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.4/MathJax.js?config=TeX-AMS_HTML',
  mathJaxClass: 'my-math',
  mathJaxDelimiter: ['<math>', '</math>'],
  toolbarGroups: [
    { groups: ['undo'] },
    { name: 'editing', groups: ['find'] },
    { name: 'basicstyles', groups: ['basicstyles'] },
    { name: 'paragraph', groups: ['list', 'indent', 'blocks'] },
    { name: 'links' },
    { name: 'insert'}
  ],
  removeButtons: 'Underline,Strike,Subscript,Superscript,Anchor,Outdent,Indent,Blockquote,Table,HorizontalRule,SpecialChar,Replace,Image'
}